import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  ViewEncapsulation,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import { User } from '../../../../models/user.model';
import { WidgetSummaryDisplayComponent } from '../../../../shared/components/widget-displays/widget-summary-display/widget-summary-display.component';
import { SharedModule } from '../../../../shared/shared.module';
import {
  getCurrentUser,
  getCurrentUserLoaded,
  getCurrentUserLoading,
  State,
} from '../../../../store';

@Component({
  selector: 'app-ons-widget-summary',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetSummaryDisplayComponent, SharedModule],
  template: `
    <app-widget-summary-display
      class="dimensions-stretch"
      [loading]="isLoading()"
      [user.firstName]="user()?.FirstName"
      [user.lastName]="user()?.LastName"
      [user.title]="user()?.Title"
      [user.phone]="user()?.Phone"
      [user.email]="user()?.Email"
      [user.accountName]="user()?.Account?.Name"
      [user.billingAddress]="userBillingAddress()"
    ></app-widget-summary-display>
  `,
})
export class WidgetSummaryComponent {
  private readonly store = inject(Store<State>);

  readonly isLoading = toSignal<boolean>(
    this.store.select(getCurrentUserLoading),
  );

  readonly isLoaded = toSignal<boolean>(
    this.store.select(getCurrentUserLoaded),
  );

  readonly user = toSignal<User>(this.store.select(getCurrentUser));

  readonly userBillingAddress = computed<string>(() => {
    const user = this.user();
    if (!user?.Account?.BillingAddress) return '';

    const { street, city, stateCode, postalCode } = user.Account
      .BillingAddress as Record<string, string>;
    return `${street}\r\n${city}, ${stateCode} ${postalCode}`;
  });
}
